import Amplify, { Auth, Hub } from 'aws-amplify'
import { useDispatch, useSelector } from 'react-redux'
import {checkUserSession, signOut} from 'src/redux/slices/auth'


// ----------------------------------------------------------------------

//const isLocal = window.location.href.indexOf('localhost') > -1

if (localStorage.getItem("eu") === "true") {
  configRegion("eu")
} else {
  configRegion("au")
}

Hub.listen('auth', ({ payload: { event, data } }) => {
  switch (event) {
    case 'signIn':
      console.log('sign in', event, data)
      break
    case 'signOut':
      console.log('sign out')
      break
    default:
      console.log('HUB', event)
      break
  }
})

export default function useAuth() {
  const dispatch = useDispatch()
  const { user } = useSelector((state) => state.auth)

  return {
    user: user,
    checkUser: (callback) => {
      dispatch(checkUserSession()).then(callback)
    },
    logout: (callback) => {
      dispatch(signOut()).then(callback)
    },
  }
}


export function configRegion(region) {
  if (region === "eu") {
    Amplify.configure({
      Auth: {
        region: 'eu-west-2',
        identityPoolId: process.env.REACT_APP_EU_COGNITO_IDENTITY_POOL_ID,
        userPoolId: process.env.REACT_APP_EU_COGNITO_USER_POOL_ID,
        userPoolWebClientId: process.env.REACT_APP_EU_COGNITO_CLIENT_ID,
        mandatorySignIn: false,
        cookieStorage: {
          domain: process.env.REACT_APP_HOST_DOMAIN,
          path: '/',
          expires: 365,
          secure: true,
        },
        redirectSignIn: process.env.REACT_APP_API_PROTOCOL + '://' + process.env.REACT_APP_HOST_DOMAIN + process.env.REACT_APP_PORT,
        redirectSignOut: process.env.REACT_APP_API_PROTOCOL + '://' + process.env.REACT_APP_HOST_DOMAIN + process.env.REACT_APP_PORT
      },
    })
    Auth.configure({
      oauth: {
        domain: process.env.REACT_APP_EU_COGNITO_AUTH_DOMAIN,
        scope: ['phone', 'email', 'profile', 'openid'],
        redirectSignIn: process.env.REACT_APP_API_PROTOCOL + '://' + process.env.REACT_APP_HOST_DOMAIN + process.env.REACT_APP_PORT,
        redirectSignOut: process.env.REACT_APP_API_PROTOCOL + '://' + process.env.REACT_APP_HOST_DOMAIN + process.env.REACT_APP_PORT,
        responseType: 'token',
      },
    })
  } else {
    //DEFAULT TO AU
    Amplify.configure({
      Auth: {
        region: 'ap-southeast-2',
        identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
        userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
        userPoolWebClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
        mandatorySignIn: false,
        cookieStorage: {
          domain: process.env.REACT_APP_HOST_DOMAIN,
          path: '/',
          expires: 365,
          secure: true,
        },
        redirectSignIn: process.env.REACT_APP_API_PROTOCOL + '://' + process.env.REACT_APP_HOST_DOMAIN + process.env.REACT_APP_PORT,
        redirectSignOut: process.env.REACT_APP_API_PROTOCOL + '://' + process.env.REACT_APP_HOST_DOMAIN + process.env.REACT_APP_PORT
      },
    })
    Auth.configure({
      oauth: {
        domain: process.env.REACT_APP_COGNITO_AUTH_DOMAIN,
        scope: ['phone', 'email', 'profile', 'openid'],
        redirectSignIn: process.env.REACT_APP_API_PROTOCOL + '://' + process.env.REACT_APP_HOST_DOMAIN + process.env.REACT_APP_PORT,
        redirectSignOut: process.env.REACT_APP_API_PROTOCOL + '://' + process.env.REACT_APP_HOST_DOMAIN + process.env.REACT_APP_PORT,
        responseType: 'token',
      },
    })
  }
}
